import HomeContentCardText from './HomeContentCardText';

export default HomeContentCardText;
